"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = Label;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _reactNative = require("react-native");
var _Text = _interopRequireDefault(require("./Text"));
var _styles = require("@sart/styles");
var _excluded = ["size", "style"];
function Label(props) {
  var size = props.size,
    style = props.style,
    rest = (0, _objectWithoutProperties2["default"])(props, _excluded);
  var labelStyles = [styles["default"], style];
  return /*#__PURE__*/_react["default"].createElement(_Text["default"], (0, _extends2["default"])({
    style: labelStyles,
    size: size
  }, rest));
}
Label.propTypes = _Text["default"].propTypes;
Label.defaultProps = Label.defaultProps || {};
Label.defaultProps.allowFontScaling = false;
var styles = _reactNative.StyleSheet.create({
  "default": {
    lineHeight: 24,
    fontWeight: '500',
    color: _styles.colors.focus
  }
});